import { WhitelabelSettingReadModel } from "../../../@api";

export const findWhitelabelSetting = (
  settings: WhitelabelSettingReadModel[],
  searchKey: string,
): WhitelabelSettingReadModel | undefined => {
  return settings.find(setting => setting.key === searchKey);
};
